export default "<template>\n\n  <KButton\n    primary\n    text=\"Flat Button\"\n    appearance=\"flat-button\"\n  />\n\n</template>\n";